<template>
  <div class="input-txt-group">
    <v-text-field
      :clearable="!disabled"
      :type="type"
      :placeholder="placeholder"
      :readonly="readonly"
      :disabled="disabled"
      :name="name"
      :min="min"
      :max="max"
      v-model="model"
      @input="onInput"
    >
    </v-text-field>
    <ErrorMessage :name="name" class="error-feedback" />
  </div>
</template>
<style lang="scss">
.error-feedback{
  color: var(--txt-red);
  font-size:1.4rem;
}
</style>
<script lang="ts" setup>
import { toRef } from "vue";
import { useField, ErrorMessage } from "vee-validate";

const props = defineProps(['placeholder', 'type' ,'readonly', 'disabled', 'modelValue', 'name', 'min', 'max' ]);
const model = defineModel()
const { value, handleBlur, errors } = useField(toRef(props, "name"), undefined,{ syncVModel: true });
//const { value, errorMessage } = useField('name', inputValue => !!inputValue);

function onInput(event: Event) {
  const input = (event.target as HTMLInputElement).value
  // type이 number일 때만 처리
  if (props.type === 'number') {
    const num = Number(input)
    model.value = isNaN(num) ? 0 : num < 0 ? 0 : num
  } else {
    model.value = input
  }
}

</script>
